import { PartialBrief } from '../../../../Types/Brief'
import { getSymbolForCurrency } from '../../../../Utilities/currencySymbol'
import { eventTypeLabels } from '../../../FormSteps/EventType/EventTypeInput'

interface EventTypeProps {
  brief: PartialBrief
}

export const EventType = ({ brief }: EventTypeProps): JSX.Element => (
  <>{eventTypeLabels[brief.collectionName ?? '']}</>
)

export default EventType
